import { lazy } from 'react';

export const MobileHomePage = lazy(() => import('../../mobile/MobileHomePage'));
export const MobileAppSettingsPage = lazy(() => import('../../mobile/MobileAppSettingsPage'));
